import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  Clients,
  UserInfo,
  DefiShieldConnections,
  Trash,
  LightNtf,
  WalletShield,
  PartnerGuard,
  Listing,
} from "../Pages";
import { MainLayout } from "../Layouts/MainLayout";
import { AssetsLists } from "../Components/AssetInsight/AssetsList";
import StakingRiskMain from "../Pages/StakingRisk/index";
import Dashboard from "../Pages/StakingRisk/Dashboard";
import CreateProduct from "../Pages/StakingRisk/CreateProduct";
import ProductDetail from "../Pages/StakingRisk/ProductDetail";
import TrashBox from "../Pages/StakingRisk/TrashBox";
import CreateCategory from "../Pages/StakingRisk/CreateCategory";

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Listing />} />
          <Route path="/list" element={<AssetsLists />} />

          <Route path="/stakingrisk" element={<StakingRiskMain />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="create-product" element={<CreateProduct />} />
            <Route path="product-detail/:id" element={<ProductDetail />} />
            <Route path="trashbox" element={<TrashBox />} />
            <Route path="create-category" element={<CreateCategory />} />
          </Route>

          <Route path="/clients" element={<Clients />} />
          <Route path="/user/:id" element={<UserInfo />} />
          <Route path="/user/trash" element={<Trash />} />
          <Route path="/light-ntf" element={<LightNtf />} />
          <Route path="/wallet-shield" element={<WalletShield />} />
          <Route path="/counterparty-risk" element={<PartnerGuard />} />
          <Route path="/defi-shield" element={<DefiShieldConnections />} />
          <Route path="/login" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
